/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimContact } from './ClaimContact';
import {
    ClaimContactFromJSON,
    ClaimContactFromJSONTyped,
    ClaimContactToJSON,
    ClaimContactToJSONTyped,
} from './ClaimContact';
import type { ClaimOrganizationsResponseMeta } from './ClaimOrganizationsResponseMeta';
import {
    ClaimOrganizationsResponseMetaFromJSON,
    ClaimOrganizationsResponseMetaFromJSONTyped,
    ClaimOrganizationsResponseMetaToJSON,
    ClaimOrganizationsResponseMetaToJSONTyped,
} from './ClaimOrganizationsResponseMeta';

/**
 * 
 * @export
 * @interface ClaimContactsResponse
 */
export interface ClaimContactsResponse {
    /**
     * 
     * @type {Array<ClaimContact>}
     * @memberof ClaimContactsResponse
     */
    claimContacts: Array<ClaimContact>;
    /**
     * 
     * @type {ClaimOrganizationsResponseMeta}
     * @memberof ClaimContactsResponse
     */
    meta: ClaimOrganizationsResponseMeta;
}

/**
 * Check if a given object implements the ClaimContactsResponse interface.
 */
export function instanceOfClaimContactsResponse(value: object): value is ClaimContactsResponse {
    if (!('claimContacts' in value) || value['claimContacts'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ClaimContactsResponseFromJSON(json: any): ClaimContactsResponse {
    return ClaimContactsResponseFromJSONTyped(json, false);
}

export function ClaimContactsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimContactsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimContacts': ((json['claimContacts'] as Array<any>).map(ClaimContactFromJSON)),
        'meta': ClaimOrganizationsResponseMetaFromJSON(json['meta']),
    };
}

export function ClaimContactsResponseToJSON(json: any): ClaimContactsResponse {
    return ClaimContactsResponseToJSONTyped(json, false);
}

export function ClaimContactsResponseToJSONTyped(value?: ClaimContactsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimContacts': ((value['claimContacts'] as Array<any>).map(ClaimContactToJSON)),
        'meta': ClaimOrganizationsResponseMetaToJSON(value['meta']),
    };
}

